import { Fragment, createElement } from "react";
import { IIconSubset } from "@fluentui/react";
import { LightningBoltSolidIcon } from "@fluentui/react-icons-mdl2";
import { themeUtils, BuiltInIconSubset } from "cayo.ui";
import styled from "styled-components";
import { endpoints } from "@cayo/shared/services/endpoints.service";
import AwsIcon from "../../images/aws.svg?react";
import CayosoftAdmin from "../../images/cayosoft-administrator.svg?react";
import CircleStar from "../../images/circleStar.svg?react";
import Complexity from "../../images/complexity.svg?react";
import Reddit from "../../images/reddit.svg?react";
import YouTube from "../../images/youtube.svg?react";
import {
  RemediationHighLevel,
  RemediationLowLevel,
  RemediationMediumLevel,
} from "../RemediationIndicator/RemediationIndicator";

const StyledLightningBoltSolidIcon = styled(LightningBoltSolidIcon)`
  display: flex;
`;

// TODO: if used only in guardian, move to guardian initTheme and expand method to accept customIcons as second arg
const customIcons: IIconSubset = {
  icons: {
    LightningBolt: <StyledLightningBoltSolidIcon />,
    Aws: createElement(AwsIcon),
    CayosoftAdmin: createElement(CayosoftAdmin),
    // suppress warning from fluentui: The icon "script+lightningbolt" was used but not registered
    "script+lightningbolt": <Fragment />,
    "server+download": <Fragment />,
    Complexity: createElement(Complexity),
    circleStar: createElement(CircleStar),
    reddit: createElement(Reddit),
    youtube: createElement(YouTube),
    Remediation_Low: createElement(RemediationLowLevel),
    Remediation_Medium: createElement(RemediationMediumLevel),
    Remediation_High: createElement(RemediationHighLevel),
  },
};

const initTheme = (subsets?: BuiltInIconSubset[]) => {
  const fontIconPath = import.meta.env.PROD ? endpoints.PUBLIC_URL : undefined;
  if (window["NONCE_ID"]) {
    themeUtils.setNonce(window["NONCE_ID"]);
  }
  themeUtils.initFonts(fontIconPath || "/", { subsets, customIcons });
};

export default initTheme;
